export enum InboundFaxStatus {
  inOcr = 'in_ocr',
  llmProcessing = 'llm_processing',
  fresh = 'fresh',
  validEvidence = 'valid_evidence',
  notValidEvidence = 'not_valid_evidence',
  needsManualIntervention = 'needs_manual_intervention',
}
